window.uploadFile = function uploadFile() {
  if (document.querySelector('[data-upload-file-animation]')) {
    const uploadFileBlocksArr = document.querySelectorAll(
      '[data-upload-file-animation]'
    );
    uploadFileBlocksArr.forEach((fileUpload) => {
      fileUpload.addEventListener('dragover', function () {
        this.classList.add('drag');
        this.classList.remove('drop', 'done');
      });

      fileUpload.addEventListener('dragleave', function () {
        this.classList.remove('drag');
      });

      fileUpload.addEventListener('drop', start, false);
      fileUpload.addEventListener('change', start, false);

      function start() {
        this.classList.remove('drag');
        this.classList.add('drop');
        setTimeout(() => this.classList.add('done'), 650);
        setTimeout(function () {
          const inputs = document.querySelectorAll(
            '.meta-upload-file__input input.error'
          );
          if (!inputs.length) return;

          inputs.forEach((input) => {
            input.classList.remove('error');

            const errorWrapper = input.closest('.error');
            if (errorWrapper) errorWrapper.classList.remove('error');

            const uploadWrapper = input.closest('.meta-upload-file');
            if (uploadWrapper) uploadWrapper.classList.remove('error');

            const errorTextEl = uploadWrapper?.querySelector('.error-text');
            if (errorTextEl) {
              errorTextEl.style.opacity = '0';
              errorTextEl.style.overflow = 'hidden';
              errorTextEl.style.maxHeight = '0px';
              errorTextEl.style.height = '0px';
            }
          });
        }, 650);
      }

      fileUpload.addEventListener('click', function () {
        fileUpload.classList.remove('error');
        const errorsElArr = fileUpload.querySelectorAll('.error');
        for (let i = 0; i < errorsElArr.length; i++) {
          errorsElArr[i].classList.remove('error');
        }
        const errorTextEl = fileUpload.querySelector('.error-text');
        if (errorTextEl) {
          errorTextEl.style.opacity = '0';
          errorTextEl.style.overflow = 'hidden';
          errorTextEl.style.maxHeight = '0px';
          errorTextEl.style.height = '0px';
        }
      });
    });
  }
};
uploadFile();

window.initMetaUploadFile = function initMetaUploadFile() {
  const metaUploadFileArr = document.querySelectorAll('.meta-upload-file');

  metaUploadFileArr.forEach((metaUploadFile) => {
    if (!metaUploadFile.classList.contains('is-init-meta-upload-file')) {
      metaUploadFile.classList.add('is-init-meta-upload-file');

      const fileNameEl = metaUploadFile.querySelector(
        '[data-meta-upload-file-name]'
      );
      const inputEl = metaUploadFile.querySelector('input');

      if (inputEl && fileNameEl) {
        inputEl.addEventListener('change', () => {
          const file = inputEl.files?.[0];
          fileNameEl.textContent = file ? file.name : 'No file selected';
        });
      }
    }
  });
};

initMetaUploadFile();
